module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_path.js
 ** module id = 529
 ** module chunks = 2 4 6 8 9 11 12
 **/